import { Logement } from "../dataModel/generated/Logement";
import { DiagnosticAccessorBase } from "../dataModel/generated/DiagnosticAccessorBase";
import { normalizeLogement } from "../dataModel/normalizeLogement";

export class LogementAccessor extends DiagnosticAccessorBase {
    constructor(logement: Logement | undefined, setter: (logement: Logement) => void) {
        super(logement, (logement: Logement) => {
            setter(normalizeLogement(logement));
        });
    }
}